export { default as DetailView } from 'fixedassets/components/AssetDetailView';



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/index.js